const audiences = [
  {
    icon: 'ri-user-star-line',
    title: 'Новые руководители',
    desc: 'Для специалистов, которые впервые переходят в управленческую роль. Помогаем освоить лидерские инструменты с первых дней и избежать типичных ошибок начинающих руководителей.',
  },
  {
    icon: 'ri-account-pin-box-line',
    title: 'Опытные руководители',
    desc: 'Для руководителей, которым необходимо повысить качество управления командой, усилить влияние и систематизировать свой управленческий подход.',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Руководители отделов продаж',
    desc: 'Для РОПов и коммерческих руководителей, которые управляют результатом через команду и которым важно сочетать лидерство с достижением бизнес-показателей.',
  },
  {
    icon: 'ri-vip-crown-line',
    title: 'Топ-менеджеры',
    desc: 'Для руководителей, работающих с изменениями, масштабированием и сложными управленческими задачами на уровне всей компании.',
  },
  {
    icon: 'ri-group-line',
    title: 'Кадровый резерв',
    desc: 'Для сотрудников, которых компания готовит к руководящим должностям. Формируем лидерское мышление до того, как они займут управленческую позицию.',
  },
  {
    icon: 'ri-team-line',
    title: 'Управленческие команды',
    desc: 'Для формирования общего понимания лидерства и единых управленческих подходов, когда важно, чтобы все руководители говорили на одном языке.',
  },
];

export default function TargetAudience() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Для кого подходит тренинг
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Программа адаптируется под уровень участников и задачи конкретной компании
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {audiences.map((a) => (
            <div key={a.title} className="bg-white rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${a.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{a.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{a.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}